var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"pt-10 pb-16 black--text text-center"},[_c('h2',{staticClass:"pb-4"},[_vm._v("지금은 제출 기간이 아닙니다.")]),_c('p',[_vm._v("기타 문의사항은 담당자 연락처로 부탁드립니다.")])])}
var staticRenderFns = []

export { render, staticRenderFns }